import { render, staticRenderFns } from "./codeAndStatus.vue?vue&type=template&id=1953c226&"
import script from "./codeAndStatus.vue?vue&type=script&lang=ts&"
export * from "./codeAndStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports